<div class="content"
     #content>
  <ng-template #templateRef></ng-template>
</div>
